export default {
  monitoring: {},
  monitorings: [],
}
